export default "__VITE_ASSET__497f231e__"